var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"softTop flex_row"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"normal flex_column",class:_vm.idx==index?'xz':'',on:{"click":function($event){return _vm.go(index)}}},_vm._l((item.info),function(info){return _c('div',{staticClass:"info"},[_vm._v(_vm._s(info))])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }